import Phaser from 'phaser';

import BaseSoupGameScene from './BaseSoupGameScene';

import { createGameLevels, createImage } from './GameFunctions';
import { gameAssets } from './LevelsConfig';

export default class CookingScene extends BaseSoupGameScene {
    //create const for name
    name = "CookingScene";

    constructor() {
        super('CookingScene');
    }

    //scene started
    init() {
        super.init();

        console.log('CookingScene init');
    }

    async create() {
        console.log('KitchenScene create');
        super.create();
        
        let scene = this;

        let game = this.game;

        this.gameObjects = await createGameLevels(scene, game, this.name);

        this.handleGameObjectSubSectionVisibility();

        //setup animation for the bay leaves and rosemary
        //since we dont have spines for this one we need to animate the gameObjects (rosemary & rosemary) manually.
        //on click we should make a copy of item and position obove the pot_topDown object and then animate it half way down the pot height

        //find the game object for the pot_topDown
        let pot_topDown = this.gameObjects.find(item => item.id === "pot_topDown");
        //get the width of the pot_topDown
        let pot_topDownX = pot_topDown.x;

        //find the game object bayLeaves
        let bayLeaves = this.gameObjects.find(item => item.id === "bayLeaves");
        let rosemary = this.gameObjects.find(item => item.id === "rosemary");
        bayLeaves.on('pointerdown', (pointer) => {

            //remove the pointerdown event listener
            bayLeaves.removeAllListeners('pointerdown');

            //set alpha to half
            bayLeaves.alpha = 0.5;

            //scene, gameObjects, item, optinalID
            createImage(scene, this.gameObjects, bayLeaves.itemConfig, "bayLeavesCopy").then(bayLeavesCopy => {
                bayLeavesCopy.alpha = 0;

                //make sure the copy is above the pot_topDown
                bayLeavesCopy.setDepth(1000);

                //scale the bayLeavesCopy down by half
                bayLeavesCopy.setScale(0.25);

                bayLeavesCopy.x = 883
                bayLeavesCopy.y = 233;

                

                // tween to move the bayLeavesCopy to the middle of the pot_topDown
                this.tweens.add({
                    targets: bayLeavesCopy,
                    alpha: 1,
                    duration: 500,
                    ease: 'Power2',
                    yoyo: false,
                    repeat: 0,
                    onComplete: () => {
                        this.tweens.add({
                            targets: bayLeavesCopy,
                            y: pot_topDown.y + 200,
                            alpha: 0,
                            duration: 1000,
                            ease: 'Power2',
                            yoyo: false,
                            repeat: 0,
                            onComplete: () => {
                                bayLeavesCopy.destroy();

                                //fade in the pot_bayLeaves
                                let pot_bayLeaves = this.gameObjects.find(item => item.id === "pot_bayLeaves");
                                this.tweens.add({
                                    targets: pot_bayLeaves,
                                    alpha: 1,
                                    duration: 1000,
                                    ease: 'Power2',
                                    yoyo: false,
                                    repeat: 0
                                });
                            }
                        });
                    }
                });

            });
        }); 

        rosemary.setInteractive(false);
        rosemary.alpha = 0.5;
        rosemary.on('pointerdown', (pointer) => {
            //remove the pointerdown event listener
            rosemary.removeAllListeners('pointerdown');

            //set alpha to half
            rosemary.alpha = 0.5;

            //scene, gameObjects, item, optinalID
            createImage(scene, this.gameObjects, rosemary.itemConfig, "rosemaryCopy").then(rosemaryCopy => {
                rosemaryCopy.alpha = 0;

                //make sure the copy is above the pot_topDown
                rosemaryCopy.setDepth(1000);

                //scale the rosemaryCopy down by half
                rosemaryCopy.setScale(0.25);
                rosemaryCopy.x = 706
                rosemaryCopy.y = 224;
                
                

                // tween to move the rosemaryCopy to the middle of the pot_topDown
                this.tweens.add({
                    targets: rosemaryCopy,
                    alpha: 1,
                    duration: 500,
                    ease: 'Power2',
                    yoyo: false,
                    repeat: 0,
                    onComplete: () => {
                        this.tweens.add({
                            targets: rosemaryCopy,
                            y: pot_topDown.y + 300,
                            alpha:0,
                            duration: 1000,
                            ease: 'Power2',
                            yoyo: false,
                            repeat: 0,
                            onComplete: () => {
                                rosemaryCopy.destroy();

                                //fade in the pot_bayLeaves
                                let pot_rosemary = this.gameObjects.find(item => item.id === "pot_rosemary");
                                this.tweens.add({
                                    targets: pot_rosemary,
                                    alpha: 1,
                                    duration: 1000,
                                    ease: 'Power2',
                                    yoyo: false,
                                    repeat: 0
                                });
                            }
                        });
                    }
                });
            });

        });

        this.game.events.emit('phaserScenePreloadEnd');
    }

    createSteam() {
        //if steam already exists, destroy it
        this.steam?.destroy();

        let ellipse = new Phaser.Geom.Ellipse(851, 524, 360, 320);

        //draw the ellipse
        // let steamEllipse = this.add.graphics({ fillStyle: { color: 0x0000ff } });
        // steamEllipse.fillEllipse(ellipse.x, ellipse.y, ellipse.width, ellipse.height);
        // steamEllipse.setInteractive(ellipse, Phaser.Geom.Ellipse.Contains);
        // this.input.setDraggable(steamEllipse);
        this.steam = this.add.particles(0, 0, 'smoke', {
            emitZone: { type: 'random', source: ellipse },
            angle: { min: -95, max: -85 },
            speed: { min: 10, max: 20 },
            scale: { start: 0.05, end: 0.3 },
            alpha: { start: 0.1, end: 0 },
            blendMode: 'SCREEN',
            lifespan: 3000, // Longer lifespan
            // Adjust these properties
            // frequency: 20, // Lower value for faster emission (e.g., 20ms)
            // quantity: 5, // Higher value for more particles per burst (e.g., 5 particles)
        });

        // Add vertical movement to the particles
        this.time.addEvent({
            loop: true,
            delay: 50,
            callback: () => {
                this.steam.forEachAlive(particle => {
                    particle.y -= 2; // Move each particle up slightly
                    particle.x += Math.sin(particle.lifeT * 0.01);
                });
            }
        });
    }

    preload() {

        //show a loading screen
        super.preload();

        this.load.spritesheet('spritesheet-steam', 'media/animations/ParticlesAndSpritesheets/steam_spritesheet_64x320_48frames.png', {
            frameWidth: 64,
            frameHeight: 320
        });

        // Load your assets here
        //iterate over the keys from gameAssets.media.images
        Object.keys(gameAssets.media.images).forEach(key => {
            let value = gameAssets.media.images[key];
            this.load.image(key, value);
        });

        // Set texture filtering
        this.load.on('filecomplete', (key, type, data) => {
            if (type === 'image') {
                this.textures.get(key).setFilter(Phaser.Textures.FilterMode.NEAREST);
            }
        });
    }

    //handle step change
    handleStepChange(currentLevel, currentLevelData, currentStep, currentStepData) {
        //check if this.currentStepData.scene is different new currentStepData.scene. If it is we need to change scenes
        if(currentStepData?.scene !== this.name){
            return;
        }

        //loop through the gameObjects and set the visibility based on the currentStepData.navID
        //if the gameObject has a navID set and it matches the currentStepData.navID, set the visibility to true otherwise set it to false (only if it has a navID)
        this.handleGameObjectSubSectionVisibility();

        console.log('handleStepChange', currentLevel, currentLevelData, currentStep, currentStepData);

        //when we enter the "subSectionID": "simmer" we need to add the boiling animation to the pot and steam
        if (currentStepData.viewId === 18){
            this.createSteam();

            console.log("adding boiling animation to pot and steam");

            let boilingSpine = this.getGameObjectByName('boilingSpine');
            if(boilingSpine){
                boilingSpine.animating = true;
                boilingSpine.alpha =0.3;

                try {
                    boilingSpine.animationState?.setAnimation(0, "boiling", false);    
                } catch (error) {
                    console.error("error setting boiling animation", error);
                }
                
            }
        }

        //on step 22 lets turn off the boiling animation
        if (currentStepData.viewId === 27){
            console.log("removing boiling animation from pot and steam");

            let boilingSpine = this.getGameObjectByName('boilingSpine');
            if(boilingSpine){
                boilingSpine.animating = false;
                boilingSpine.alpha =0;


                try {
                    boilingSpine.animationState?.setAnimation(0, "boiling", false);
                } catch (error) {
                    console.error("Error setting animation:", error);
                }
            }

            //stop the steam emitter
            //fade it out and then destroy it
            this.tweens.add({
                targets: this.steam,
                alpha: 0,
                duration: 1000,
                ease: 'Power2',
                yoyo: false,
                repeat: 0,
                onComplete: () => {
                    this.steam?.destroy();
                }
            });
        }

        //on step 23, lets play the ladlePour animation on the ladelSpinePour spine
        //also lets play the bowlSpine bowlFilling animation
        if (currentStepData.viewId === 28) {
            console.log("playing ladlePour animation");

            let ladleSpinePour = this.getGameObjectByName('ladelSpinePour');
            if (ladleSpinePour) {
                ladleSpinePour.animating = true;
                ladleSpinePour.alpha = 1;
                ladleSpinePour.play("ladlePour", false);
            }

            let bowlSpine = this.getGameObjectByName('bowlSpine');
            if (bowlSpine) {
                bowlSpine.animating = true;
                bowlSpine.alpha = 1;
                setTimeout(() => {
                    try {
                        bowlSpine.play("bowlFilling", false);    
                    } catch (error) {
                        console.error("error setting animation", error);
                        
                    }
                }, 1200)
            }

        }

        //setup default views to ensure pot is populated
        
        //on viewId 13 add carrots ,celery, and onion and oil to the pot
        if (currentStepData.viewId === 13) {
            console.log("adding carrots, celery, and onion to pot");

            //objects: pot_carrots_stage1, pot_celery_stage1, pot_onions_stage1, pot_oliveOil_stage1
            //if none of the object are visible then set them all to visible
            //otherwise leave them as they are
            let potObjects = ['pot_carrots_stage1', 'pot_celery_stage1', 'pot_onions_stage1', 'pot_oliveOil_stage1'];
            let oneVisable = false;
            potObjects.forEach(potObject => {
                let potObj = this.getGameObjectByName(potObject);
                if (!oneVisable) {
                    if (potObj && potObj.alpha === 1) {
                        oneVisable = true;
                    }
                }
            });
            if(!oneVisable){
                potObjects.forEach(potObject => {
                    let pot = this.getGameObjectByName(potObject);
                    if (pot) {
                        pot.alpha = 1;
                    }
                });
            }
        }

        //on view 18 ensure the pot_tomatoes are added
        if (currentStepData.viewId === 18) {
            console.log("adding tomatoes to pot");

            let pot_tomatoes = this.getGameObjectByName('pot_tomatoes');
            if (pot_tomatoes) {
                pot_tomatoes.alpha = 1;
            }
        }

        //on view 22 ensure the pot_water is added
        if (currentStepData.viewId === 22) {
            console.log("adding water to pot");

            let pot_water = this.getGameObjectByName('pot_water1');
            if (pot_water) {
                pot_water.alpha = 1;
            }

            //hide pot_tomatoes
            let pot_tomatoes = this.getGameObjectByName('pot_tomatoes');
            if (pot_tomatoes) {
                pot_tomatoes.alpha = 0;
            }
        }

        if (currentStepData.viewId === 24) {
            console.log("hide water 1 and show 2");

            let pot_water = this.getGameObjectByName('pot_water1');
            if (pot_water) {
                pot_water.alpha = 0;
            }

            let pot_water2 = this.getGameObjectByName('pot_water2');
            if (pot_water2) {
                pot_water2.alpha = 1;
            }
        }

        //hide post_water1 and post_water1 since post_water will be visible
        if (currentStepData.viewId === 27) {
            console.log("adding water to pot");

            let pot_water1 = this.getGameObjectByName('pot_water1');
            if (pot_water1) {
                //fade out
                pot_water1.alpha = 0;
            }

            let pot_water2 = this.getGameObjectByName('pot_water2');
            if (pot_water2) {
                pot_water2.alpha = 0;
            }
            
        }



        //this is for going backwards
        if (currentStepData.viewId >= 23) {
            //ensure at least pot_water1 is visible, check if pot_water1, pot_water2, or pot_water are visible
            let pot_water1 = this.getGameObjectByName('pot_water1');
            let pot_water2 = this.getGameObjectByName('pot_water2');
            let pot_water = this.getGameObjectByName('pot_water');
            let oneVisable = false;
            if (pot_water1 && pot_water1.alpha === 1) {
                oneVisable = true;
            }
            if (pot_water2 && pot_water2.alpha === 1) {
                oneVisable = true;
            }
            if (pot_water && pot_water.alpha === 1) {
                oneVisable = true;
            }
            if (!oneVisable) {
                pot_water1.alpha = 1;
            }
        }

    }

    shutdown() {
        console.log('CookingScene shutdown');

        //loop through all game objects and call destroy if it exists
        //also call this.tweens.killTweensOf(item) if it exists
        this.gameObjects.forEach(item => {
            if (this.tweens.killTweensOf) {
                this.tweens.killTweensOf(item);
            }
            if (item.destroy) {
                item.destroy();
            }
        });

        // Stop all active tweens
        this.tweens.killAll();

        super.destroy();
    }

    destroy() {
        this.tweens.killAll();
        
        this.steam?.destroy();

        super.destroy();

    }

}